import React, { Component } from 'react';
import RecommendedProduct from './recommended-product';
import TextWithTooltip from '../text-with-tooltip';
import { trimArray } from '../../app-actions';
import {
  MARKET_COMPARISON_INITIAL_PRODUCT_COUNT,
} from '../../app-constants';
import { readmore, ReadMoreContext } from '../read-more-text/readMoreContext';

export const toggleOn = ({ on, children }) => (
  on ? children : null
);

class ProductRecommendationsView extends Component {
  constructor(props) {
    super(props);
    this.onClickViewAll = this.onClickViewAll.bind(this);
    this.updateAllProductRecommendation = props.actions.updateAllProductRecommendation;
    this.state = {
      viewAll: false,
      selectAll: false,
      useModal: readmore.useModal,
    };
  }

  onClickViewAll() {
    this.setState({
      viewAll: true,
    });
  }

  /* if viewAll is selected then show all recommondations else show only first five */
  filterProductsForDisplay(productRecommendation) {
    return this.state.viewAll ?
      productRecommendation
      : trimArray(productRecommendation, MARKET_COMPARISON_INITIAL_PRODUCT_COUNT);
  }

  render() {
    const { productRecommendation, authorableContent, cidn } = this.props;
    const productRecommendationForDisplay = this.filterProductsForDisplay(productRecommendation);
    const { accordionHeading, accordionContent, viewAllButtonText } = authorableContent;
    const {
      product,
      productToolTip,
      addRemoveProduct,
      marketPercentage,
      increasedPercentage,
      marketPercentageToolTip,
      increasedPercentageToolTip,
    } = accordionHeading;
    const heading = (
      <li className="list-group-item">
        <div className="row">
          <div className="col-11 pr-0 pr-sm-2">
            <div className="row">
              <div className="d-flex align-items-sm-center col-6 col-sm-4 product-container">
                <TextWithTooltip
                  labelText={product}
                  text={<i className="td-icon icon-help" />}
                  textClassName="help-icon-container"
                  toolTipText={productToolTip}
                  id="tooltiptext-product-recommended-heading"
                />
              </div>
              <div className="add-remove-product-container col-3 offset-2 offset-sm-1 col-sm-2 text-center px-0">
                <p className="mb-0">{addRemoveProduct}</p>
              </div>
              <div className="market-percentage d-none d-sm-flex col-sm-2 text-center px-0 align-items-sm-center">
                <TextWithTooltip
                  labelText={marketPercentage}
                  text={<i className="td-icon icon-help" />}
                  textClassName="help-icon-container"
                  toolTipText={marketPercentageToolTip}
                  id="tooltiptext-market-comparison-heading"
                />
              </div>
              <div className="increased-percentage d-none d-sm-flex col-sm-3 text-center align-items-sm-center">
                <div className="pl-1">
                  <TextWithTooltip
                    labelText={increasedPercentage}
                    text={<i className="td-icon icon-help" />}
                    textClassName="help-icon-container"
                    toolTipText={increasedPercentageToolTip}
                    id="tooltiptext-increased-percentage-heading"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    );
    /* View all recommendations button - to be hidden when the button is clicked */
    const viewAllComponent = (
      !this.state.viewAll &&
      <li className="list-group-item view-all-container" onClick={this.onClickViewAll} role="presentation">
        <div className="view-all-button-text text-center">
          {viewAllButtonText}
        </div>
      </li>
    );
    return (
      <div className="card">
        <ul className="list-group list-group-flush product-recommendations row mx-sm-0">
          {heading}
          <ReadMoreContext.Provider value={this.state.useModal}>
            {productRecommendationForDisplay.map(productData => (
              <RecommendedProduct
                cidn={cidn}
                productData={productData}
                key={productData.recommendedProductCode}
                authorableContent={accordionContent}
              />
            ))
            }
          </ReadMoreContext.Provider>
          {/* Show view-all only when product recommendation is greater than inital-product-count */}
          {productRecommendation.length > MARKET_COMPARISON_INITIAL_PRODUCT_COUNT && viewAllComponent}
        </ul>
      </div>
    );
  }
}

ProductRecommendationsView.On = toggleOn;
export default ProductRecommendationsView;
